import React, { useContext, useState } from "react";
import BaseTopBar from "../../Components/topbars/BaseTopBar";
import { NavObjectType, lddGlobalSessionInfo } from "../../Components/navigationTypes";
import { Offcanvas, ListGroup, Modal, Nav, OverlayTrigger, Tooltip } from "react-bootstrap";
import { NavigationContext } from "../../Context/NavigationContext";
import styles from '../../Components/mainbar.module.css';
import { useAppSelector } from "../../redux/hooks";
import { topBarConfig } from "./topBarConfig";
import Loading from "../../Components/Loading";
import UpdatePasswordModal from "../../Components/UpdatePassword/UpdatePasswordModal";


function ShowSettingsCanvas() {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const nav = useContext(NavigationContext);
    const SessionInfo: lddGlobalSessionInfo = useAppSelector((state) => state.SessionInfo);
    const isAdmin = SessionInfo?.user?.isAdmin;
    const OpenBilling: NavObjectType = { component: "main", url: "/rplus/ON/lfmaster.asp", popup: false, params: { 'NoHeader': '1', 'adhoc': '1', 'formasp': 'ShowAccountStatement' } };

    const ShowManageUsers = ({ sid }) => {
        const [show, setShow] = useState(false);
    
        const handleClose = () => setShow(false);
        const handleShow = () => setShow(!show);
        return (<>
            <ListGroup.Item className={styles.menuItem} action onClick={handleShow}>Manage Users</ListGroup.Item>
            <Modal show={show} onHide={handleClose} className="modal-settings modal-list" backdrop={false}>
                <iframe 
                    title="User Management" 
                    src={`${window.location.origin}/${process.env.REACT_APP_UM_ENDPOINT}/index.html?SessionID=${sid}`} 
                    width="100%" 
                    height="100%" 
                />
            </Modal>
        </>)
    }
    
    const ShowManageLawyers = ({ sid }) => {
        const [show, setShow] = useState(false);
        const [isLoading, setIsLoading] = useState(true);
        const handleClose = () => {setShow(false); setIsLoading(true);};
        const handleShow = () => setShow(!show);
        return (<>
            <ListGroup.Item className={styles.menuItem} action onClick={handleShow}>Lawyer & Notary Management</ListGroup.Item>
            <Modal show={show} onHide={handleClose} className="modal-settings modal-list" backdrop={false}>
                <Modal.Header closeButton>
                    <Modal.Title as={'h1'}>Lawyer & Notary Management</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {isLoading && <Loading />}
                    <iframe
                        title="Lawyer & Notary Management"
                        src={`${window.location.origin}/${process.env.REACT_APP_VIP_ENDPOINT}/LDDUserSetting.asp?Lawyer=&SessionID=${sid}`}
                        width="100%"
                        height="100%"
                        onLoad={() => setIsLoading(false)} />
                </Modal.Body>
            </Modal>
        </>)
    }

    
    return (
        <>
            <Nav.Item className={styles.item}>
                <OverlayTrigger placement="bottom" delay={200} overlay={
                    <Tooltip>Settings</Tooltip>
                }>
                    <Nav.Link eventKey="link-4"><i className="fa-duotone fa-gear fa-indicator" onClick={handleShow}></i></Nav.Link>
                </OverlayTrigger>
            </Nav.Item>

            <Offcanvas show={show} onHide={handleClose} placement="end" className="settings-menu" scroll>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Settings</Offcanvas.Title>
                </Offcanvas.Header>

                <Offcanvas.Body className={styles.settingsTabs}>
                    <div className="settings-tabs">
                        {isAdmin && 
                            <>
                            {SidebarTitle("Account", "fa-duotone fa-user fa-indicator")}
                            <ListGroup variant="flush">
                                <ShowManageUsers sid={SessionInfo.sid} />
                                <ShowManageLawyers sid={SessionInfo.sid} />
                            </ListGroup>
                        </>
                        }

                        {SidebarTitle("Billing", "fa-duotone fa-file-invoice fa-indicator")}

                        <ListGroup variant="flush">
                            {SessionInfo && SidebarAction("Billing Statements", OpenBilling, SessionInfo.sid, nav, handleClose)}
                        </ListGroup>
                        
                    </div>
                </Offcanvas.Body>
            </Offcanvas >
        </>
    );
}
function SidebarTitle(title: string, icon: string) {
    return (
        <h4><i className={icon}></i>{title}</h4>
    )
}

function SidebarAction(title: string, click: NavObjectType, sid: string, nav: (click: NavObjectType) => void, closeSidebar: () => void) {
    return (
        <ListGroup.Item className={styles.menuItem} action onClick={() => { nav(click); closeSidebar() }}>{title}</ListGroup.Item>
    )
}

const TopBar = () => {
    const nav = useContext(NavigationContext);
    const [showUpdatePasswordModal, setShowUpdatePasswordModal] = useState(false);
    const sessionInfo = useAppSelector((state) => state.SessionInfo);
    const page = useAppSelector((state) => state.currentNavigation?.page);
    const OpenMainPage: NavObjectType = { component: "dr" };
    const actions = {
        "OpenMainPage": () => {if (sessionInfo) nav(OpenMainPage)},
        "OpenSettings": () => {
            return <ShowSettingsCanvas key={"setting-canvas"} />;
        },
        "OpenPasswordUpdate": () => setShowUpdatePasswordModal(true),
    }
    
    return (
        <>
            <BaseTopBar
                topBarConfig={topBarConfig}
                actions={actions}
                sessionInfo={sessionInfo}
                sid={sessionInfo?.sid}
                page={page}
            />
            <UpdatePasswordModal
                show={showUpdatePasswordModal}
                onHide={() => setShowUpdatePasswordModal(false)}
            />
        </>
    );
};

export default TopBar;
